var config = require('../config.js')
module.exports = {
    saveAddress: config.host + '/tktinc/api/v1/receivingAddress/save/c', //新增修改收货地址
    getDefaultAddress: config.host + '/tktinc/api/v1/receivingAddress/getDefault/c', //获取默认收货地址
    getAddressList: config.host + '/tktinc/api/v1/receivingAddress/listByPage/c', //获取收货地址列表
    setDefaultAddress: config.host + '/tktinc/api/v1/receivingAddress/setDefault/c', //设置默认收货地址
    deleteAddress: config.host + '/tktinc/api/v1/receivingAddress/delete/c', //删除收货地址
}